import { entryCards } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function EntryGrid() {
  return (
    <section id="entry" className="border-t border-background-200 bg-background-50">
      <div className="px-4 py-12 md:px-6 md:py-16">
        <div className="mx-auto max-w-page">
          <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
            <SectionHeading
              index="01 / 入口索引"
              title="按终端与用途，把所有入口归成一张索引"
              desc="官网主站、最新地址、备用线路、App 与电脑版都在这里，先认用途再点入口，比盲目换域名更快。"
            />
            <span className="shrink-0 font-label text-xs tracking-[0.2em] text-foreground-500">
              共 {entryCards.length} 类入口 · 全部可用
            </span>
          </div>

          <div className="mt-9 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 md:gap-5">
            {entryCards.map((card) => (
              <article
                key={card.id}
                className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:bg-background-100"
              >
                <div className="flex items-start justify-between">
                  <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                    <i className={`${card.icon} text-2xl`} />
                  </span>
                  {card.hot && (
                    <span className="rounded-full border border-accent-200 bg-accent-50 px-2 py-0.5 text-[11px] text-accent-700">
                      热门
                    </span>
                  )}
                </div>
                <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">
                  {card.title}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">
                  {card.summary}
                </p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3">
                  <span className="rounded-full bg-secondary-100 px-2.5 py-1 text-xs text-secondary-800">
                    {card.tag}
                  </span>
                  <a
                    href="#guide"
                    className="inline-flex cursor-pointer items-center gap-1 whitespace-nowrap text-sm text-primary-700"
                  >
                    进入 <i className="ri-arrow-right-line" />
                  </a>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}